import "./EventsTableDetails.html";
import "./EventsTableDetails.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EventsTableDetailsComponentController from "./EventsTableDetailsComponentController";

export default class EventsTableDetailsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            eventId: "<",
            site: "<",
        };

        this.controller = EventsTableDetailsComponentController;
        this.templateUrl = "/App/Components/Site/Events/EventsTable/EventsTableDetails/EventsTableDetails.html";
    }
}

module("mmGui").component("irEventsTableDetails", new EventsTableDetailsComponent());
